/**
 * Created by nijin on 30/6/17.
 */
import {Component, OnInit, Input, OnChanges} from '@angular/core';

@Component({
    selector: 'nuc-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, OnChanges {

    @Input() lat;
    @Input() lng;
    constructor() { }


    ngOnInit() {

    }

    ngOnChanges() {

    }

}



// WEBPACK FOOTER //
// ./src/app/things/things-details/location-details/map.component.ts